import { render, staticRenderFns } from "./WebCheckin.vue?vue&type=template&id=5c70f496&"
import script from "./WebCheckin.vue?vue&type=script&lang=js&"
export * from "./WebCheckin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports